export const internCVList = [
  {
    category: "quant",
    company: "Morgan Stanley",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sobhan_Mishra_resume_2026.png",
    createdAt: "2026-07-15T14:30:00.000Z",
    dept: "CE",
    id: 284,
    name_: "Sobhan Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sobhan_Mishra_resume_thumb.png",
    title: "Morgan Stanley | CE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arpit_Yadav_resume_2026.png",
    createdAt: "2026-07-15T05:30:00.000Z",
    dept: "EE",
    id: 283,
    name_: "Arpit Yadav",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arpit_Yadav_resume_thumb.png",
    title: "Siemens EDA | EE",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Oishik_Nandi_resume_2026.png",
    createdAt: "2026-07-14T14:30:00.000Z",
    dept: "EE",
    id: 282,
    name_: "Oishik Nandi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Oishik_Nandi_resume_thumb.png",
    title: "Texas Instruments | EE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Mastercard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Akshat_Jiwrajka_resume_2026.png",
    createdAt: "2026-07-14T05:30:00.000Z",
    dept: "MA",
    id: 281,
    name_: "Akshat Jiwrajka",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Akshat_Jiwrajka_resume_thumb.png",
    title: "Mastercard | MA",
    hasResume: true,
  },
  {
    category: "software",
    company: "Databricks",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Abhinav_Akarsh_resume_2026.png",
    createdAt: "2026-07-13T14:30:00.000Z",
    dept: "CS",
    id: 280,
    name_: "Abhinav Akarsh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Abhinav_Akarsh_resume_thumb.png",
    title: "Databricks | CS",
    hasResume: true,
  },
  {
    category: "software",
    company: "Kognitos Software Private Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Vedanshi_Panda_resume_2026.jpg",
    createdAt: "2026-07-13T14:30:00.000Z",
    dept: "MA",
    id: 253,
    name_: "Vedanshi Panda",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Vedanshi_Panda_resume_thumb.png",
    title: "Kognitos Software Private Limited | MA",
    hasResume: true,
  },
  {
    category: "data",
    company: "BlackRock",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Anushree_Ghosh_resume_2026.png",
    createdAt: "2026-07-13T05:30:00.000Z",
    dept: "CH",
    id: 279,
    name_: "Anushree Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Anushree_Ghosh_resume_thumb.png",
    title: "BlackRock | CH",
    hasResume: true,
  },
  {
    category: "software",
    company: "DE Shaw",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harsh_Raj_resume_2026.png",
    createdAt: "2026-07-12T14:30:00.000Z",
    dept: "EC",
    id: 278,
    name_: "Harsh Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harsh_Raj_resume_thumb.png",
    title: "DE Shaw | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "Atlassian",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Yellapu_Dheeraj_Babu_resume_2026.jpg",
    createdAt: "2026-07-12T14:30:00.000Z",
    dept: "CS",
    id: 250,
    name_: "Yellapu Dheeraj Babu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Yellapu_Dheeraj_Babu_resume_thumb.png",
    title: "Atlassian | CS",
    hasResume: true,
  },
  {
    category: "quant",
    company: "JP Morgan Chase & Co.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shaurya_Baranwal_resume_2026.png",
    createdAt: "2026-07-12T05:30:00.000Z",
    dept: "IM",
    id: 277,
    name_: "Shaurya Baranwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shaurya_Baranwal_resume_thumb.png",
    title: "JP Morgan Chase & Co. | IM",
    hasResume: true,
  },
  {
    category: "data",
    company: "Honeywell",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shamik_Bhattacharjee_resume_2026.jpg",
    createdAt: "2026-07-11T14:30:00.000Z",
    dept: "CH",
    id: 248,
    name_: "Shamik Bhattacharjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shamik_Bhattacharjee_resume_thumb.png",
    title: "Honeywell | CH",
    hasResume: true,
  },
  {
    category: "finance",
    company: "Millenium",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Thota_Rithvik_resume_2026.png",
    createdAt: "2026-07-11T05:30:00.000Z",
    dept: "CS",
    id: 276,
    name_: "Thota Rithvik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Thota_Rithvik_resume_thumb.png",
    title: "Millenium | CS",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/P_Vamshi_Krishna_resume_2026.jpg",
    createdAt: "2026-07-11T05:30:00.000Z",
    dept: "EC",
    id: 247,
    name_: "P Vamshi Krishna",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/P_Vamshi_Krishna_resume_thumb.png",
    title: "Texas Instruments | EC",
    hasResume: true,
  },
  {
    category: "core",
    company: "bp",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Suryansh_Pandey_resume_2026.png",
    createdAt: "2026-07-09T14:30:00.000Z",
    dept: "EX",
    id: 273,
    name_: "Suryansh Pandey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Suryansh_Pandey_resume_thumb.png",
    title: "bp | EX",
    hasResume: true,
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Fazal_Hayat_Khan_resume_2026.png",
    createdAt: "2026-07-09T05:30:00.000Z",
    dept: "EC",
    id: 272,
    name_: "Fazal Hayat Khan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Fazal_Hayat_Khan_resume_thumb.png",
    title: "Microsoft | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "FinMechanics",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Eshita_Jain_resume_2026.png",
    createdAt: "2026-07-08T14:30:00.000Z",
    dept: "ME",
    id: 271,
    name_: "Eshita Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Eshita_Jain_resume_thumb.png",
    title: "FinMechanics | ME",
    hasResume: true,
  },
  {
    category: "software",
    company: "DE Shaw",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Nikhil_Kalur_resume_2026.png",
    createdAt: "2026-07-08T05:30:00.000Z",
    dept: "EC",
    id: 270,
    name_: "Nikhil Kalur",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Nikhil_Kalur_resume_thumb.png",
    title: "DE Shaw | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "UnifyApps",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Soumil_Kumar_resume_2026.png",
    createdAt: "2026-07-07T14:30:00.000Z",
    dept: "BT",
    id: 269,
    name_: "Soumil Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Soumil_Kumar_resume_thumb.png",
    title: "UnifyApps | BT",
    hasResume: true,
  },
  {
    category: "data",
    company: "BlackRock",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Srajan_Kumar_Gupta_resume_2026.png",
    createdAt: "2026-07-07T05:30:00.000Z",
    dept: "ME",
    id: 268,
    name_: "Srajan Kumar Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Srajan_Kumar_Gupta_resume_thumb.png",
    title: "BlackRock | ME",
    hasResume: true,
  },
  {
    category: "software",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mauryavardhan_Singh_resume_2026.png",
    createdAt: "2026-07-06T14:30:00.000Z",
    dept: "ME",
    id: 267,
    name_: "Mauryavardhan Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mauryavardhan_Singh_resume_thumb.png",
    title: "Adobe | ME",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments India",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Debarshi_Basak_resume_2026.jpg",
    createdAt: "2026-07-05T14:30:00.000Z",
    dept: "EC",
    id: 264,
    name_: "Debarshi Basak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Debarshi_Basak_resume_thumb.png",
    title: "Texas Instruments India | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "ICICI Bank",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Raj_Majumder_resume_2026.jpg",
    createdAt: "2026-07-05T05:30:00.000Z",
    dept: "CH",
    id: 263,
    name_: "Raj Majumder",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Raj_Majumder_resume_thumb.png",
    title: "ICICI Bank | CH",
    hasResume: true,
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Adithya_Ananthanarayanan_resume_2026.jpg",
    createdAt: "2026-07-04T14:30:00.000Z",
    dept: "EE",
    id: 262,
    name_: "Adithya Ananthanarayanan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Adithya_Ananthanarayanan_resume_thumb.png",
    title: "Microsoft | EE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Samsung Research Institute Bangalore(SRIB)",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sayak_Sardar_resume_2026.jpg",
    createdAt: "2026-07-04T05:30:00.000Z",
    dept: "EE",
    id: 261,
    name_: "Sayak Sardar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sayak_Sardar_resume_thumb.png",
    title: "Samsung Research Institute Bangalore(SRIB) | EE",
    hasResume: true,
  },
  {
    category: "finance",
    company: "Nomura",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jyotishka_Biswas_resume_2026.jpg",
    createdAt: "2026-07-03T14:30:00.000Z",
    dept: "NA",
    id: 260,
    name_: "Jyotishka Biswas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jyotishka_Biswas_resume_thumb.png",
    title: "Nomura | NA",
    hasResume: true,
  },
  {
    category: "data",
    company: "Mastercard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Utkarsh_Patel_resume_2026.jpg",
    createdAt: "2026-07-03T05:30:00.000Z",
    dept: "EE",
    id: 259,
    name_: "Utkarsh Patel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Utkarsh_Patel_resume_thumb.png",
    title: "Mastercard | EE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Shivam_Maji_resume_2026.jpg",
    createdAt: "2026-07-02T14:30:00.000Z",
    dept: "ECE",
    id: 258,
    name_: "Shivam Maji",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Shivam_Maji_resume_thumb.png",
    title: "Adobe | ECE",
    hasResume: true,
  },
  {
    category: "consultancy",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sarthak_Rajeshkumar_Patel_resume_2026.jpg",
    createdAt: "2026-07-02T05:30:00.000Z",
    dept: "IM",
    id: 257,
    name_: "Sarthak Rajeshkumar Patel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sarthak_Rajeshkumar_Patel_resume_thumb.png",
    title: "Accenture | IM",
    hasResume: true,
  },
  {
    category: "core",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Chiradip_Biswas_resume_2026.jpg",
    createdAt: "2026-07-01T14:30:00.000Z",
    dept: "EC",
    id: 256,
    name_: "Chiradip Biswas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Chiradip_Biswas_resume_thumb.png",
    title: "Google | EC",
    hasResume: true,
  },
  {
    category: "data",
    company: "AWL",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harsh_Bhatt_resume_2026.png",
    createdAt: "2026-07-01T09:30:00.000Z",
    dept: "CH",
    id: 266,
    name_: "Harsh Bhatt",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harsh_Bhatt_resume_thumb.png",
    title: "AWL | CH",
    hasResume: true,
  },
  {
    category: "data",
    company: "BlackRock",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jiten_Shah_resume_2026.jpg",
    createdAt: "2026-06-30T14:30:00.000Z",
    dept: "CH",
    id: 238,
    name_: "Jiten Shah",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jiten_Shah_resume_thumb.png",
    title: "BlackRock | CH",
    hasResume: true,
  },
  {
    category: "data",
    company: "BlackRock",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Satyam_Mishra_resume_2026.jpg",
    createdAt: "2026-06-30T08:30:00.000Z",
    dept: "EX",
    id: 255,
    name_: "Satyam Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Satyam_Mishra_resume_thumb.png",
    title: "BlackRock | EX",
    hasResume: true,
  },
  {
    category: "software",
    company: "Atlassian",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jatin_Mahawar_resume_2026.jpg",
    createdAt: "2026-06-30T05:30:00.000Z",
    dept: "CS",
    id: 237,
    name_: "Jatin Mahawar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jatin_Mahawar_resume_thumb.png",
    title: "Atlassian | CS",
    hasResume: true,
  },
  {
    category: "data",
    company: "No Broker",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Neelabh_Verma_resume_2026.jpg",
    createdAt: "2026-06-29T14:30:00.000Z",
    dept: "AR",
    id: 236,
    name_: "Neelabh Verma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Neelabh_Verma_resume_thumb.png",
    title: "No Broker | AR",
    hasResume: true,
  },
  {
    category: "software",
    company: "Samsara",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Jai_Raj_resume_2026.jpg",
    createdAt: "2026-06-29T05:30:00.000Z",
    dept: "EC",
    id: 235,
    name_: "Jai Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Jai_Raj_resume_thumb.png",
    title: "Samsara | EC",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kushagra_Hathiwala_resume_2026.jpg",
    createdAt: "2026-06-28T14:30:00.000Z",
    dept: "IE",
    id: 240,
    name_: "Kushagra Hathiwala",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kushagra_Hathiwala_resume_thumb.png",
    title: "Texas Instruments | IE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Intuit",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Rwik_Dey_resume_2026.jpg",
    createdAt: "2026-06-28T05:30:00.000Z",
    dept: "EE",
    id: 233,
    name_: "Rwik Dey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Rwik_Dey_resume_thumb.png",
    title: "Intuit | EE",
    hasResume: true,
  },
  {
    category: "quant",
    company: "Wells Fargo",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aarya_Yogesh_Pakhale_resume_2026.jpg",
    createdAt: "2026-06-27T14:30:00.000Z",
    dept: "MT",
    id: 232,
    name_: "Aarya Yogesh Pakhale",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aarya_Yogesh_Pakhale_resume_thumb.png",
    title: "Wells Fargo | MT",
    hasResume: true,
  },
  {
    category: "core",
    company: "Hindustan Unilever Limited",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Biswajit_Debnath_resume_2026.jpg",
    createdAt: "2026-06-27T05:30:00.000Z",
    dept: "MT",
    id: 231,
    name_: "Biswajit Debnath",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Biswajit_Debnath_resume_thumb.png",
    title: "Hindustan Unilever Limited | MT",
    hasResume: true,
  },
  {
    category: "software",
    company: "Quadeye",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Diganta_Mandal_resume_2026.jpg",
    createdAt: "2026-06-26T05:30:00.000Z",
    dept: "CS",
    id: 239,
    name_: "Diganta Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Diganta_Mandal_resume_thumb.png",
    title: "Quadeye | CS",
    hasResume: true,
  },
  {
    category: "software",
    company: "Unifyapps",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Saakshi_Baranwal_resume_2026.jpg",
    createdAt: "2026-06-25T14:30:00.000Z",
    dept: "CH",
    id: 229,
    name_: "Saakshi Baranwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Saakshi_Baranwal_resume_thumb.png",
    title: "Unifyapps | CH",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Chandan_Karmakar_resume_2026.jpg",
    createdAt: "2026-06-25T05:30:00.000Z",
    dept: "EC",
    id: 228,
    name_: "Chandan Karmakar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Chandan_Karmakar_resume_thumb.png",
    title: "Texas Instruments | EC",
    hasResume: true,
  },
  {
    category: "data",
    company: "HUL",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sharvari_Ramesh_Wanjari_resume_2026.jpg",
    createdAt: "2026-06-24T14:30:00.000Z",
    dept: "CS",
    id: 227,
    name_: "Sharvari Ramesh Wanjari",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sharvari_Ramesh_Wanjari_resume_thumb.png",
    title: "HUL | CS",
    hasResume: true,
  },
  {
    category: "software",
    company: "Eternal",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Appari_Jai_Deep_Sreevas_resume_2026.jpg",
    createdAt: "2026-06-24T05:30:00.000Z",
    dept: "MA",
    id: 226,
    name_: "Appari Jai Deep Sreevas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Appari_Jai_Deep_Sreevas_resume_thumb.png",
    title: "Eternal | MA",
    hasResume: true,
  },
  {
    category: "core",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sanjay_R_resume_2026.jpg",
    createdAt: "2026-06-23T14:30:00.000Z",
    dept: "EC",
    id: 225,
    name_: "Sanjay R",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sanjay_R_resume_thumb.png",
    title: "Siemens EDA | EC",
    hasResume: true,
  },
  {
    category: "product",
    company: "Purplle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kartikey_Patel_resume_2026.jpg",
    createdAt: "2026-06-23T05:30:00.000Z",
    dept: "ME",
    id: 224,
    name_: "Kartikey Patel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kartikey_Patel_resume_thumb.png",
    title: "Purplle | ME",
    hasResume: true,
  },
  {
    category: "data",
    company: "Info Edge",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kunal_Mandal_resume_2026.jpg",
    createdAt: "2026-06-22T14:30:00.000Z",
    dept: "ME",
    id: 223,
    name_: "Kunal Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kunal_Mandal_resume_thumb.png",
    title: "Info Edge | ME",
    hasResume: true,
  },
  {
    category: "product",
    company: "Purplle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Snehal_Pal_resume_2026.jpg",
    createdAt: "2026-06-22T05:30:00.000Z",
    dept: "CH",
    id: 222,
    name_: "Snehal Pal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Snehal_Pal_resume_thumb.png",
    title: "Purplle | CH",
    hasResume: true,
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/ARKA_DAS_resume_2026.jpg",
    createdAt: "2026-06-21T14:30:00.000Z",
    dept: "EE",
    id: 221,
    name_: "ARKA DAS",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/ARKA_DAS_resume_thumb.png",
    title: "Texas Instruments | EE",
    hasResume: true,
  },
  {
    category: "fmcg",
    company: "Hindustan Unilever (HUL)",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Samarth_Jauhal_resume_2026.jpg",
    createdAt: "2026-06-21T05:30:00.000Z",
    dept: "ME",
    id: 220,
    name_: "Samarth Jauhal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Samarth_Jauhal_resume_thumb.png",
    title: "Hindustan Unilever (HUL) | ME",
    hasResume: true,
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Hardik_Jagga_resume_2026.jpg",
    createdAt: "2026-06-20T14:30:00.000Z",
    dept: "EC",
    id: 219,
    name_: "Hardik Jagga",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Hardik_Jagga_resume_thumb.png",
    title: "NVIDIA | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "SIEMENS EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mishukh_Shil_resume_2026.jpg",
    createdAt: "2026-06-20T05:30:00.000Z",
    dept: "EE",
    id: 218,
    name_: "Mishukh Shil",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mishukh_Shil_resume_thumb.png",
    title: "SIEMENS EDA | EE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Subham_Ghosh_resume_2026.jpg",
    createdAt: "2026-06-19T14:30:00.000Z",
    dept: "EE",
    id: 217,
    name_: "Subham Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Subham_Ghosh_resume_thumb.png",
    title: "Qualcomm | EE",
    hasResume: true,
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Pragya_Pathak_resume_2026.jpg",
    createdAt: "2026-06-19T05:30:00.000Z",
    dept: "HS",
    id: 216,
    name_: "Pragya Pathak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Pragya_Pathak_resume_thumb.png",
    title: "American Express | HS",
    hasResume: true,
  },
  {
    category: "software",
    company: "AMAZON",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Uday_Keshav_resume_2026.jpg",
    createdAt: "2026-06-18T14:30:00.000Z",
    dept: "EE",
    id: 215,
    name_: "Uday Keshav",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Uday_Keshav_resume_thumb.png",
    title: "AMAZON | EE",
    hasResume: true,
  },
  {
    category: "consultancy",
    company: "Boston Consulting Group (BCG)",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Kevin_Jais_resume_2026.jpg",
    createdAt: "2026-06-18T05:30:00.000Z",
    dept: "AE",
    id: 214,
    name_: "Kevin Jais",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Kevin_Jais_resume_thumb.png",
    title: "Boston Consulting Group (BCG) | AE",
    hasResume: true,
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Disha_Mukherjee_resume_2026.jpg",
    createdAt: "2026-06-17T14:30:00.000Z",
    dept: "CH",
    id: 213,
    name_: "Disha Mukherjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Disha_Mukherjee_resume_thumb.png",
    title: "American Express | CH",
    hasResume: true,
  },
  {
    category: "core",
    company: "Bajaj Auto Ltd",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Akshith_Kumar_Bettam_resume_2026.jpg",
    createdAt: "2026-06-17T05:30:00.000Z",
    dept: "ME",
    id: 212,
    name_: "Akshith Kumar Bettam",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Akshith_Kumar_Bettam_resume_thumb.png",
    title: "Bajaj Auto Ltd | ME",
    hasResume: true,
  },
  {
    category: "fmcg",
    company: "ITC Ltd",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Parag_Agarwal_resume_2026.jpg",
    createdAt: "2026-06-16T14:30:00.000Z",
    dept: "IM",
    id: 211,
    name_: "Parag Agarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Parag_Agarwal_resume_thumb.png",
    title: "ITC Ltd | IM",
    hasResume: true,
  },
  {
    category: "data",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Devodita_Chakravarty_resume_2026.jpg",
    createdAt: "2026-06-15T14:30:00.000Z",
    dept: "ME",
    id: 209,
    name_: "Devodita Chakravarty",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Devodita_Chakravarty_resume_thumb.png",
    title: "Adobe | ME",
    hasResume: true,
  },
  {
    category: "consultancy",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arka_Ghosh_resume_2026.jpg",
    createdAt: "2026-06-15T05:30:00.000Z",
    dept: "EE",
    id: 210,
    name_: "Arka Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arka_Ghosh_resume_thumb.png",
    title: "Accenture | EE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Harsh_Gupta_resume_2026.jpg",
    createdAt: "2026-06-15T05:30:00.000Z",
    dept: "ME",
    id: 208,
    name_: "Harsh Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Harsh_Gupta_resume_thumb.png",
    title: "Goldman Sachs | ME",
    hasResume: true,
  },
  {
    category: "data",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Siddharth_Jain_resume_2026.jpg",
    createdAt: "2026-06-14T14:30:00.000Z",
    dept: "ME",
    id: 207,
    name_: "Siddharth Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Siddharth_Jain_resume_thumb.png",
    title: "Accenture | ME",
    hasResume: true,
  },
  {
    category: "software",
    company: "Salesforce",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Koushik_Debnath_resume_2026.jpg",
    createdAt: "2026-06-14T05:30:00.000Z",
    dept: "IE",
    id: 196,
    name_: "Koushik Debnath",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Koushik_Debnath_resume_thumb.png",
    title: "Salesforce | IE",
    hasResume: true,
  },
  {
    category: "quant",
    company: "JP Morgan Chase & Co.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Sreedeep_Chatterjee_resume_2026.jpg",
    createdAt: "2026-06-13T14:30:00.000Z",
    dept: "IE",
    id: 195,
    name_: "Sreedeep Chatterjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Sreedeep_Chatterjee_resume_thumb.png",
    title: "JP Morgan Chase & Co. | IE",
    hasResume: true,
  },
  {
    category: "software",
    company: "Stripe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Saksham_Aggarwal_resume_2026.jpg",
    createdAt: "2026-06-13T05:30:00.000Z",
    dept: "EC",
    id: 194,
    name_: "Saksham Aggarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Saksham_Aggarwal_resume_thumb.png",
    title: "Stripe | EC",
    hasResume: true,
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Arup_Basak_resume_2026.jpg",
    createdAt: "2026-06-12T14:30:00.000Z",
    dept: "EC",
    id: 193,
    name_: "Arup Basak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Arup_Basak_resume_thumb.png",
    title: "NVIDIA | EC",
    hasResume: true,
  },
  {
    category: "data",
    company: "Fidelity Investments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Saikat_Mondal_resume_2026.jpg",
    createdAt: "2026-06-12T05:30:00.000Z",
    dept: "CH",
    id: 192,
    name_: "Saikat Mondal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Saikat_Mondal_resume_thumb.png",
    title: "Fidelity Investments | CH",
    hasResume: true,
  },
  {
    category: "data",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Aryan_Lohia_resume_2026.jpg",
    createdAt: "2026-06-11T05:30:00.000Z",
    dept: "MA",
    id: 190,
    name_: "Aryan Lohia",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Aryan_Lohia_resume_thumb.png",
    title: "Adobe | MA",
    hasResume: true,
  },
  {
    category: "consultancy",
    company: "Accenture",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ankit_Anand_resume_2026.jpg",
    createdAt: "2026-06-10T14:30:00.000Z",
    dept: "CH",
    id: 189,
    name_: "Ankit Anand",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ankit_Anand_resume_thumb.png",
    title: "Accenture | CH",
    hasResume: true,
  },
  {
    category: "consultancy",
    company: "L.E.K. Consulting",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Amish_Bhatnagar_resume_2026.jpg",
    createdAt: "2026-06-10T05:30:00.000Z",
    dept: "CH",
    id: 188,
    name_: "Amish Bhatnagar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Amish_Bhatnagar_resume_thumb.png",
    title: "L.E.K. Consulting | CH",
    hasResume: true,
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Nimit_Khandelwal_resume_2026.jpg",
    createdAt: "2026-06-09T14:30:00.000Z",
    dept: "EC",
    id: 187,
    name_: "Nimit Khandelwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Nimit_Khandelwal_resume_thumb.png",
    title: "Google | EC",
    hasResume: true,
  },
  {
    category: "software",
    company: "Mercari",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Utsav_Mandal_cv_2025.png",
    createdAt: "2025-08-31T11:04:24.706Z",
    dept: "IE",
    id: 186,
    name_: "Utsav Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Utsav_Mandal_cv_2025.png",
    title: "Mercari | IE",
  },
  {
    category: "software",
    company: "JLR",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MNIKdIiE-3x6a3-pIY96Ow.jpeg",
    createdAt: "2025-07-01T22:24:04.812Z",
    dept: "EC",
    id: 1,
    name_: "Daksh Varshney",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*MNIKdIiE-3x6a3-pIY96Ow.jpeg",
    title: "JLR | EC",
  },
  {
    category: "finance",
    company: "JPMC",
    cover: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*LK33wAoyFvFwDjMw0hqxzQ.jpeg",
    createdAt: "2025-07-01T22:24:04.683Z",
    dept: "MT",
    id: 2,
    name_: "Vaishnavi Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*LK33wAoyFvFwDjMw0hqxzQ.jpeg",
    title: "JPMC | MT",
  },
  {
    category: "core",
    company: "Nvidia",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*3cKBnK7ymiaprVpNBfB2Sw.png",
    createdAt: "2025-07-01T22:24:04.553Z",
    dept: "EC",
    id: 3,
    name_: "Gidugu Srikar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*3cKBnK7ymiaprVpNBfB2Sw.png",
    title: "Nvidia | EC",
  },
  {
    category: "software",
    company: "Honeywell",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*1hm-gev_rvr_HZ7rDvqBxA.png",
    createdAt: "2025-07-01T22:24:04.423Z",
    dept: "IM",
    id: 4,
    name_: "Utkarshini Dubey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*1hm-gev_rvr_HZ7rDvqBxA.png",
    title: "Honeywell | IM",
  },
  {
    category: "data",
    company: "AWL",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*V8RVXrzAYEcS9GyDzjHdYA.jpeg",
    createdAt: "2025-07-01T22:24:04.294Z",
    dept: "EC",
    id: 5,
    name_: "Shubham Kulkarni",
    profilecolor: "green",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*V8RVXrzAYEcS9GyDzjHdYA.jpeg",
    title: "AWL|EC",
  },
  {
    category: "consultancy",
    company: "Bain & Co.",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*dHrn75J0kHwkVsq34W4Q-w.jpeg",
    createdAt: "2025-07-01T22:24:04.160Z",
    dept: "EE",
    id: 6,
    name_: "Bharat Uday",
    profilecolor: "Red",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*dHrn75J0kHwkVsq34W4Q-w.jpeg",
    title: " Bain & Co. | EE",
  },
  {
    category: "finance",
    company: "Morgan Stanley",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*owWIzFdeBIdBFvZgu5VNPA.jpeg",
    createdAt: "2025-07-01T22:24:04.030Z",
    dept: "HS",
    id: 7,
    name_: "Priyansha",
    profilecolor: "orange",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*owWIzFdeBIdBFvZgu5VNPA.jpeg",
    title: "Morgan Stanley | HS",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MPPhQ8ausn0aqJ861Z49TA.jpeg",
    createdAt: "2025-07-01T22:24:03.899Z",
    dept: "EC",
    id: 8,
    name_: "Rashi Patil",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*MPPhQ8ausn0aqJ861Z49TA.jpeg",
    title: "Google | EC",
  },
  {
    category: "quant",
    company: "APT",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*7JIVCogdWnGyP-P0oGXgfQ.jpeg",
    createdAt: "2025-07-01T22:24:03.763Z",
    dept: "IM",
    id: 9,
    name_: "Ishan Manchaanda",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*7JIVCogdWnGyP-P0oGXgfQ.jpeg",
    title: "APT | IM",
  },
  {
    category: "software",
    company: "Honeywell",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*-EryacxM0sZ-8HgU3Za-sQ.jpeg",
    createdAt: "2025-07-01T22:24:03.634Z",
    dept: "ME",
    id: 10,
    name_: "Rithick Prabakar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*-EryacxM0sZ-8HgU3Za-sQ.jpeg",
    title: "Honeywell |ME",
  },
  {
    category: "software",
    company: "Goldman Sachs",
    cover: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg",
    createdAt: "2025-07-01T22:24:03.504Z",
    dept: "ME",
    id: 11,
    name_: "Himadri Pandya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg",
    title: "GS|ME",
  },
  {
    category: "data",
    company: "EXL Services",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/snehacv.png",
    createdAt: "2025-07-01T22:24:03.363Z",
    dept: "CH",
    id: 12,
    name_: "Sneha Majumder",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/snehacv.png",
    title: "EXL Services | CH",
  },
  {
    category: "data",
    company: "Tiger Analytics",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/rajdeepcv.png",
    createdAt: "2025-07-01T22:24:03.233Z",
    dept: "BT",
    id: 13,
    name_: "Rajdeep Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/rajdeepcv.png",
    title: "Tiger Analytics | BT",
  },
  {
    category: "software",
    company: "DE Shaw",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*juOBrjqu3HPXZp-5vx7dUg.jpeg",
    createdAt: "2025-07-01T22:24:03.103Z",
    dept: "EC",
    id: 14,
    name_: "Jothi Prakash",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*juOBrjqu3HPXZp-5vx7dUg.jpeg",
    title: "DE Shaw | EC",
  },
  {
    category: "software",
    company: "Sprinklr",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*gTNcDFGV9TpQCxyK-hHukQ.jpeg",
    createdAt: "2025-07-01T22:24:02.970Z",
    dept: "CS",
    id: 15,
    name_: "Gaurav Malakar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*gTNcDFGV9TpQCxyK-hHukQ.jpeg",
    title: "Sprinklr | CS",
  },
  {
    category: "data",
    company: "Udaan",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/tuhincv.png",
    createdAt: "2025-07-01T22:24:02.841Z",
    dept: "CE",
    id: 16,
    name_: "Tuhin Subhra De",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/tuhincv.png",
    title: "Udaan | CE",
  },
  {
    category: "core",
    company: "JLR",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/polucv.png",
    createdAt: "2025-07-01T22:24:02.571Z",
    dept: "EE",
    id: 18,
    name_: "Polu Sreenidhi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/polucv.png",
    title: "JLR | EE",
  },
  {
    category: "core",
    company: "Bajaj",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/preeticv.png",
    createdAt: "2025-07-01T22:24:02.310Z",
    dept: "EE",
    id: 20,
    name_: "Preeti Nilanjana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/preeticv.png",
    title: "Bajaj | EE",
  },
  {
    category: "quant",
    company: "Morgan Stanley",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mayank_Agarwal_cv_2026.png",
    createdAt: "2025-07-01T22:24:02.181Z",
    dept: "MA",
    id: 21,
    name_: "Mayank Agarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mayank_Agarwal_cv_2026.png",
    title: "Morgan Stanley | MA",
  },
  {
    category: "consultancy",
    company: "LEK",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Diya_Sarkar_cv_2026.png",
    createdAt: "2025-07-01T22:24:02.050Z",
    dept: "CH",
    id: 22,
    name_: "Diya Sarkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Diya_Sarkar_cv_2026.png",
    title: "LEK | CH",
  },
  {
    category: "data",
    company: "Info Edge Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/bhargavcv.png",
    createdAt: "2025-07-01T22:24:01.919Z",
    dept: "NA",
    id: 23,
    name_: "Bhargav Khare",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/bhargavcv.png",
    title: "Info Edge Ltd. | NA",
  },
  {
    category: "product",
    company: "PnG",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/kalidindi_cv.png",
    createdAt: "2025-07-01T22:24:01.011Z",
    dept: "IM",
    id: 30,
    name_: "Kalidindi Rohan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/kalidindi_cv.png",
    title: "PnG | IM",
  },
  {
    category: "quant",
    company: "AlphaGrep",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/nabhya_cv.png",
    createdAt: "2025-07-01T22:24:00.882Z",
    dept: "MA",
    id: 31,
    name_: "Nabhya Khoria",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/nabhya_cv.png",
    title: "AlphaGrep | MA",
  },
  {
    category: "core",
    company: "JLR",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/sayantan_cv.png",
    createdAt: "2025-07-01T22:24:00.752Z",
    dept: "ME",
    id: 32,
    name_: "Sayantan Sarkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/sayantan_cv.png",
    title: "JLR | ME",
  },
  {
    category: "software",
    company: "Graviton Research Capital LLP",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/swapnil_cv.png",
    createdAt: "2025-07-01T22:24:00.622Z",
    dept: "CS",
    id: 33,
    name_: "Swapnil Yasasvi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/swapnil_cv.png",
    title: "Graviton Research Capital LLP | CS",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/birru_cv.jpg",
    createdAt: "2025-07-01T22:24:00.487Z",
    dept: "HS",
    id: 34,
    name_: "Birru Lavanya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/birru_cv.jpg",
    title: "Goldman Sachs | HS",
  },
  {
    category: "software",
    company: "Graviton Research Capital LLP",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/abhijeet_cv.jpg",
    createdAt: "2025-07-01T22:24:00.358Z",
    dept: "CS",
    id: 35,
    name_: "Abhijeet Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/abhijeet_cv.jpg",
    title: "Graviton Research Capital LLP | CS",
  },
  {
    category: "software",
    company: "Sprinklr",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/abhirup_cv.jpg",
    createdAt: "2025-07-01T22:24:00.228Z",
    dept: "IM",
    id: 36,
    name_: "Abhirup Pal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/abhirup_cv.jpg",
    title: "Sprinklr | IM",
  },
  {
    category: "software",
    company: "Sprinklr",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/debaditya_cv.jpg",
    createdAt: "2025-07-01T22:24:00.098Z",
    dept: "CS",
    id: 37,
    name_: "Debaditya Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/debaditya_cv.jpg",
    title: "Sprinklr | CS",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/vipin_cv.jpg",
    createdAt: "2025-07-01T22:23:59.966Z",
    dept: "ME",
    id: 38,
    name_: "Vipin",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/vipin_cv.jpg",
    title: "Goldman Sachs | ME",
  },
  {
    category: "core",
    company: "Bajaj",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/rohit_cv.jpg",
    createdAt: "2025-07-01T22:23:59.835Z",
    dept: "MT",
    id: 39,
    name_: "Rohit R Gaikwad",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/rohit_cv.jpg",
    title: "Bajaj | MT",
  },
  {
    category: "software",
    company: "Sprinklr",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/arjit_cv.jpg",
    createdAt: "2025-07-01T22:23:59.694Z",
    dept: "EC",
    id: 40,
    name_: "Arjit Lohia",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/arjit_cv.jpg",
    title: "Sprinklr | EC",
  },
  {
    category: "software",
    company: "Databricks",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/bhuvan_cv.jpg",
    createdAt: "2025-07-01T22:23:59.554Z",
    dept: "MA",
    id: 41,
    name_: "Bhuvan Rangoju",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/bhuvan_cv.jpg",
    title: "Databricks | MA",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/sanskar_cv.jpg",
    createdAt: "2025-07-01T22:23:59.406Z",
    dept: "HS",
    id: 42,
    name_: "Sanskar Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/sanskar_cv.jpg",
    title: "Goldman Sachs | HS",
  },
  {
    category: "software",
    company: "Nutanix",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/amit_cv.jpg",
    createdAt: "2025-07-01T22:23:59.274Z",
    dept: "CS",
    id: 43,
    name_: "Amit Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/amit_cv.jpg",
    title: "Nutanix | CS",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/kshitij_cv.jpg",
    createdAt: "2025-07-01T22:23:59.125Z",
    dept: "EE",
    id: 44,
    name_: "Kshitij Banerjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/kshitij_cv.jpg",
    title: "Texas Instruments | EE",
  },
  {
    category: "consultancy",
    company: "LEK",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Abhyank_Singh_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.980Z",
    dept: "EX",
    id: 45,
    name_: "Abhyank Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Abhyank_Singh_cv_2026.png",
    title: "LEK | EX",
  },
  {
    category: "software",
    company: "AlphaGrep",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/pranav_cv.jpg",
    createdAt: "2025-07-01T22:23:58.838Z",
    dept: "CS",
    id: 46,
    name_: "Pranav Kulkarni",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/pranav_cv.jpg",
    title: "AlphaGrep | CS",
  },
  {
    category: "data",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/N_Anushka_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.698Z",
    dept: "EC",
    id: 47,
    name_: "N Anushka",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/N_Anushka_cv_2026.png",
    title: "Adobe | EC",
  },
  {
    category: "finance",
    company: "Nomura",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Tejas_Saxena_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.556Z",
    dept: "CH",
    id: 48,
    name_: "Tejas Saxena",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Tejas_Saxena_cv_2026.png",
    title: "Nomura | CH",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Ayushi_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.412Z",
    dept: "IE",
    id: 49,
    name_: "Ayushi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Ayushi_cv_2026.png",
    title: "Microsoft | IE",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Avi_Saraf_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.273Z",
    dept: "EE",
    id: 50,
    name_: "Avi Saraf",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Avi_Saraf_cv_2026.png",
    title: "Texas Instruments | EE",
  },
  {
    category: "software",
    company: "WinZo Games",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Khush_Bajaj_cv_2026.png",
    createdAt: "2025-07-01T22:23:58.132Z",
    dept: "CS",
    id: 51,
    name_: "Khush Bajaj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Khush_Bajaj_cv_2026.png",
    title: "WinZo Games | CS",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Mohd_Amaan_cv_2026.png",
    createdAt: "2025-07-01T22:23:57.992Z",
    dept: "EE",
    id: 52,
    name_: "Mohd Amaan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Mohd_Amaan_cv_2026.png",
    title: "Amazon | EE",
  },
  {
    category: "data",
    company: "JM Financial Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Malla_Dhanraj_cv_2026.png",
    createdAt: "2025-07-01T22:23:57.716Z",
    dept: "IM",
    id: 54,
    name_: "Malla Dhanraj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Malla_Dhanraj_cv_2026.png",
    title: "JM Financial Ltd. | IM",
  },
  {
    category: "software",
    company: "Salesforce",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Himdyuti_Sandilya_cv_2026.png",
    createdAt: "2025-07-01T22:23:57.575Z",
    dept: "EE",
    id: 55,
    name_: "Himdyuti Sandilya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Himdyuti_Sandilya_cv_2026.png",
    title: "Salesforce | EE",
  },
  {
    category: "consultancy",
    company: "Accenture",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*V8RVXrzAYEcS9GyDzjHdYA.jpeg",
    createdAt: "2025-07-01T22:23:57.433Z",
    dept: "MI",
    id: 56,
    name_: "Archana Satapathy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*AB0Ltkv8Ix159UrdO1xmhg.jpeg",
    title: "Accenture | MI",
  },
  {
    category: "core",
    company: "Nvidia",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/sneharghya_cv.jpg",
    createdAt: "2025-07-01T22:23:57.299Z",
    dept: "EC",
    id: 57,
    name_: "Sneharghya Debnath",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/sneharghya_cv.jpg",
    title: "Nvidia | EC",
  },
  {
    category: "data",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Neeraj_cv.png",
    createdAt: "2025-07-01T22:23:57.159Z",
    dept: "CS",
    id: 58,
    name_: "Neeraj Boddeda",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Neeraj_cv.png",
    title: "Microsoft | CS",
  },
  {
    category: "software",
    company: "VISA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Krishna_cv.png",
    createdAt: "2025-07-01T22:23:57.021Z",
    dept: "EE",
    id: 59,
    name_: "Krishna Kolte",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Krishna_cv.png",
    title: "VISA | EE",
  },
  {
    category: "software",
    company: "Oracle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shatansh_cv.png",
    createdAt: "2025-07-01T22:23:56.881Z",
    dept: "MA",
    id: 60,
    name_: "Shatansh Patnaik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shatansh_cv.png",
    title: "Oracle | MA",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Muskan_cv.png",
    createdAt: "2025-07-01T22:23:56.738Z",
    dept: "CY",
    id: 61,
    name_: "Muskan Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Muskan_cv.png",
    title: "Microsoft | CY",
  },
  {
    category: "product",
    company: "RAAM Group",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Diptendu_cv.png",
    createdAt: "2025-07-01T22:23:56.597Z",
    dept: "ME",
    id: 62,
    name_: "Diptendu Sarkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Diptendu_cv.png",
    title: "RAAM Group | ME",
  },
  {
    category: "software",
    company: "Oracle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rajarshi_cv.png",
    createdAt: "2025-07-01T22:23:56.456Z",
    dept: "EC",
    id: 63,
    name_: "Rajarshi Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rajarshi_cv.png",
    title: "Oracle | EC",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Debanu_cv1.png",
    createdAt: "2025-07-01T22:23:56.314Z",
    dept: "EC",
    id: 64,
    name_: "Debanu Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Debanu_cv1.png",
    title: "Texas Instruments | EC",
  },
  {
    category: "data",
    company: "EXL Services",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Pravalika_cv.png",
    createdAt: "2025-07-01T22:23:56.171Z",
    dept: "CH",
    id: 65,
    name_: "Pravalika Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Pravalika_cv.png",
    title: "EXL Services | CH",
  },
  {
    category: "quant",
    company: "Nomura",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Pranshul_cv.png",
    createdAt: "2025-07-01T22:23:56.014Z",
    dept: "MA",
    id: 66,
    name_: "Pranshul Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Pranshul_cv.png",
    title: "Nomura | MA",
  },
  {
    category: "core",
    company: "HUL",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Saheb_cv.png",
    createdAt: "2025-07-01T22:23:55.875Z",
    dept: "CH",
    id: 67,
    name_: "Saheb Lohakare",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Saheb_cv.png",
    title: "HUL | CH",
  },
  {
    category: "software",
    company: "Sprinklr",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Vedant_cv.png",
    createdAt: "2025-07-01T22:23:55.733Z",
    dept: "IM",
    id: 68,
    name_: "Vedant Tarole",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Vedant_cv.png",
    title: "Sprinklr | IM",
  },
  {
    category: "product",
    company: "TATA AIG",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Tanish_cv.png",
    createdAt: "2025-07-01T22:23:55.591Z",
    dept: "ME",
    id: 69,
    name_: "Tanish Goel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Tanish_cv.png",
    title: "TATA AIG | ME",
  },
  {
    category: "consultancy",
    company: "McKinsey & Co",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Samarth_cv.png",
    createdAt: "2025-07-01T22:23:55.449Z",
    dept: "ME",
    id: 70,
    name_: "Samarth Singh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Samarth_cv.png",
    title: "McKinsey & Co | ME",
  },
  {
    category: "software",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sanidhya_cv.png",
    createdAt: "2025-07-01T22:23:55.319Z",
    dept: "MA",
    id: 71,
    name_: "Sanidhya Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sanidhya_cv.png",
    title: "Texas Instruments | MA",
  },
  {
    category: "software",
    company: "Oracle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rajarshi_cv.png",
    createdAt: "2025-07-01T22:23:55.174Z",
    dept: "EC",
    id: 72,
    name_: "Rajarshi Mandal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rajarshi_cv.png",
    title: "Oracle | EC",
  },
  {
    category: "software",
    company: "Mastercard",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Khushi_cv.png",
    createdAt: "2025-07-01T22:23:55.042Z",
    dept: "IE",
    id: 73,
    name_: "Khushi Agrawal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Khushi_cv.png",
    title: "Mastercard | IE",
  },
  {
    category: "data",
    company: "TATA AIG",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Prachi_cv.png",
    createdAt: "2025-07-01T22:23:54.901Z",
    dept: "GG",
    id: 74,
    name_: "Prachi Priya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Prachi_cv.png",
    title: "TATA AIG | GG",
  },
  {
    category: "core",
    company: "Menon & Menon Pvt. Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Jainish_cv.png",
    createdAt: "2025-07-01T22:23:54.768Z",
    dept: "AE",
    id: 75,
    name_: "Jainish Solanki",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Jainish_cv.png",
    title: "Menon & Menon Pvt. Ltd. | AE",
  },
  {
    category: "software",
    company: "Menon & Menon Pvt. Ltd.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Priyank_cv.png",
    createdAt: "2025-07-01T22:23:54.629Z",
    dept: "EC",
    id: 76,
    name_: "Priyank Mundra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Priyank_cv.png",
    title: "BNY Mellon | EC",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Dillip_cv.png",
    createdAt: "2025-07-01T22:23:54.490Z",
    dept: "EC",
    id: 77,
    name_: "Dillip Dibyajyoti Dash",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Dillip_cv.png",
    title: "Qualcomm | EC",
  },
  {
    category: "software",
    company: "Oracle",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/aryankumar_cv.png",
    createdAt: "2025-07-01T22:23:54.344Z",
    dept: "IM",
    id: 78,
    name_: "Aryan Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/aryankumar_cv.png",
    title: "Oracle | IM",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shelly_cv.png",
    createdAt: "2025-07-01T22:23:54.204Z",
    dept: "IE",
    id: 79,
    name_: "Shelly Aggarwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shelly_cv.png",
    title: "Google | IE",
  },
  {
    category: "software",
    company: "Limechat",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Zaid_cv.png",
    createdAt: "2025-07-01T22:23:54.064Z",
    dept: "EE",
    id: 80,
    name_: "Zaid Irfan Ali",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Zaid_cv.png",
    title: "Limechat | EE",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/harshitha_cv.png",
    createdAt: "2025-07-01T22:23:53.921Z",
    dept: "CS",
    id: 81,
    name_: "Gaddam Sree Harshitha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/harshitha_cv.png",
    title: "Google | CS",
  },
  {
    category: "software",
    company: "Standard Chartered",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Kunal_cv.png",
    createdAt: "2025-07-01T22:23:53.780Z",
    dept: "MA",
    id: 82,
    name_: "Kunal Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Kunal_cv.png",
    title: "Standard Chartered | MA",
  },
  {
    category: "product",
    company: "JM Financial Ltd. ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Riyan_cv.png",
    createdAt: "2025-07-01T22:23:53.639Z",
    dept: "MT",
    id: 83,
    name_: "Riyan Biswas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Riyan_cv.png",
    title: "JM Financial Ltd. | MT",
  },
  {
    category: "data",
    company: "Fidelity Investments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shubh_cv.png",
    createdAt: "2025-07-01T22:23:53.458Z",
    dept: "BT",
    id: 84,
    name_: "Shubh Guwalani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shubh_cv.png",
    title: "Fidelity Investments | BT",
  },
  {
    category: "software",
    company: "Uber",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sourabh_cv.png",
    createdAt: "2025-07-01T22:23:53.327Z",
    dept: "CS",
    id: 85,
    name_: "Sourabh Soumyakanta Das",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sourabh_cv.png",
    title: "Uber | CS",
  },
  {
    category: "software",
    company: "Eightfold.Ai",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Abhisekh_Mukherjee_cv.png",
    createdAt: "2025-07-01T22:23:53.196Z",
    dept: "MA",
    id: 86,
    name_: "Abhisekh Mukherjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Abhisekh_Mukherjee_cv.png",
    title: "Eightfold.Ai | MA",
  },
  {
    category: "software",
    company: "Zepto",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Adarsh_Tadiparthi_cv_2026.png",
    createdAt: "2025-07-01T22:23:53.061Z",
    dept: "EE",
    id: 87,
    name_: "Adarsh Tadiparthi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Adarsh_Tadiparthi_cv_2026.png",
    title: "Zepto | EE",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aditya_Nandy_cv.png",
    createdAt: "2025-07-01T22:23:52.927Z",
    dept: "EE",
    id: 88,
    name_: "Aditya Nandy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aditya_Nandy_cv.png",
    title: "American Express | EE",
  },
  {
    category: "core",
    company: "Bajaj Auto",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aditya_Prakash_cv.png",
    createdAt: "2025-07-01T22:23:52.796Z",
    dept: "ME",
    id: 89,
    name_: "Aditya Prakash",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aditya_Prakash_cv.png",
    title: "Bajaj Auto | ME",
  },
  {
    category: "quant",
    company: "Graviton Research Capital LLP",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aditya_Panda_cv.png",
    createdAt: "2025-07-01T22:23:52.663Z",
    dept: "EC",
    id: 90,
    name_: "Aditya Panda",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aditya_Panda_cv.png",
    title: "Graviton Research Capital LLP | EC",
  },
  {
    category: "product",
    company: "Procter and Gamble",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aditya_Singh_Dabas_cv.png",
    createdAt: "2025-07-01T22:23:52.532Z",
    dept: "MF",
    id: 91,
    name_: "Aditya Singh Dabas",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aditya_Singh_Dabas_cv.png",
    title: "Procter and Gamble | MF",
  },
  {
    category: "finance",
    company: "Axxela",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Akshat_Lathi_cv.png",
    createdAt: "2025-07-01T22:23:52.402Z",
    dept: "CY",
    id: 92,
    name_: "Akshat Lathi",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Akshat_Lathi_cv.png",
    title: "Axxela | CY",
  },
  {
    category: "software",
    company: "Samsung R&D Institute Bangalore",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Akshat_Pandey_cv.png",
    createdAt: "2025-07-01T22:23:52.271Z",
    dept: "CS",
    id: 93,
    name_: "Akshat Pandey",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Akshat_Pandey_cv.png",
    title: "Samsung R&D Institute Bangalore | CS",
  },
  {
    category: "core",
    company: "Johnson & Johnson",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Amrita_Ghosh_cv.png",
    createdAt: "2025-07-01T22:23:52.139Z",
    dept: "ME",
    id: 94,
    name_: "Amrita Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Amrita_Ghosh_cv.png",
    title: "Johnson & Johnson | ME",
  },
  {
    category: "data",
    company: "Battery Smart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ankit_Dutta_cv.png",
    createdAt: "2025-07-01T22:23:52.007Z",
    dept: "GG",
    id: 95,
    name_: "Ankit Dutta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ankit_Dutta_cv.png",
    title: "Battery Smart | GG",
  },
  {
    category: "software",
    company: "Adobe",
    cover: "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg",
    createdAt: "2025-07-01T22:23:51.875Z",
    dept: "EC",
    id: 96,
    name_: "Avik Halder",
    profilecolor: "#FFC0CB",
    thumbnail: "https://miro.medium.com/v2/resize:fit:500/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg",
    title: "Adobe | EC",
  },
  {
    category: "quant",
    company: "JP Morgan Chase & Co.",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Bhanu_Pratap_cv.png",
    createdAt: "2025-07-01T22:23:51.744Z",
    dept: "MA",
    id: 97,
    name_: "Bhanu Pratap",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Bhanu_Pratap_cv.png",
    title: "JP Morgan Chase & Co. | MA",
  },
  {
    category: "finance",
    company: "Nomura",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Biswajeet_Nayak_cv.png",
    createdAt: "2025-07-01T22:23:51.613Z",
    dept: "CH",
    id: 98,
    name_: "Biswajeet Nayak",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Biswajeet_Nayak_cv.png",
    title: "Nomura | CH",
  },
  {
    category: "consultancy",
    company: "Khurana and Khurana",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/DHANAVATH_PRANAY_NAIK_cv.png",
    createdAt: "2025-07-01T22:23:51.483Z",
    dept: "IP",
    id: 99,
    name_: "Dhanavath Pranay Naik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/DHANAVATH_PRANAY_NAIK_cv.png",
    title: "Khurana and Khurana | IP",
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Deep_Ghosh_cv.png",
    createdAt: "2025-07-01T22:23:51.353Z",
    dept: "EC",
    id: 100,
    name_: "Deep Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Deep_Ghosh_cv.png",
    title: "NVIDIA | EC",
  },
  {
    category: "consultancy",
    company: "Zepto",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Dhruv_Parikh_cv.png",
    createdAt: "2025-07-01T22:23:51.221Z",
    dept: "CH",
    id: 101,
    name_: "Dhruv Parikh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Dhruv_Parikh_cv.png",
    title: "Zepto | CH",
  },
  {
    category: "core",
    company: "Johnson & Johnson",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Harsh_Gupta_cv.png",
    createdAt: "2025-07-01T22:23:51.090Z",
    dept: "CH",
    id: 102,
    name_: "Harsh Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Harsh_Gupta_cv.png",
    title: "Johnson & Johnson | CH",
  },
  {
    category: "data",
    company: "OLA Krutrim",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Irsh_Vijay_cv.png",
    createdAt: "2025-07-01T22:23:50.958Z",
    dept: "EC",
    id: 103,
    name_: "Irsh Vijay",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Irsh_Vijay_cv.png",
    title: "OLA Krutrim | EC",
  },
  {
    category: "software",
    company: "ThoughtSpot",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Jitendra_Bhati_cv.png",
    createdAt: "2025-07-01T22:23:50.823Z",
    dept: "BT",
    id: 104,
    name_: "Jitendra Bhati",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Jitendra_Bhati_cv.png",
    title: "ThoughtSpot | BT",
  },
  {
    category: "software",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Jyotiraditya_Harichandan_cv.png",
    createdAt: "2025-07-01T22:23:50.692Z",
    dept: "EE",
    id: 105,
    name_: "Jyotiraditya Harichandan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Jyotiraditya_Harichandan_cv.png",
    title: "Siemens EDA | EE",
  },
  {
    category: "core",
    company: "APT Portfolio",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Hrushikesh_Reddy_cv.png",
    createdAt: "2025-07-01T22:23:50.559Z",
    dept: "CS",
    id: 106,
    name_: "Kalikiri Hrushikesh Reddy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Hrushikesh_Reddy_cv.png",
    title: "APT Portfolio | CS",
  },
  {
    category: "software",
    company: "SRI Noida",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Md_Mutahhir_Azam_cv.png",
    createdAt: "2025-07-01T22:23:50.427Z",
    dept: "IE",
    id: 107,
    name_: "Md Mutahhir Azam",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Md_Mutahhir_Azam_cv.png",
    title: "SRI Noida | IE",
  },
  {
    category: "consultancy",
    company: "Nation With NaMo",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aryan_Kubal_cv.png",
    createdAt: "2025-07-01T22:23:50.295Z",
    dept: "MT",
    id: 108,
    name_: "Kubal Aryan Nilesh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aryan_Kubal_cv.png",
    title: "Nation With NaMo | MT",
  },
  {
    category: "software",
    company: "Siemens EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Konduri_Jeevan_Varma_cv.png",
    createdAt: "2025-07-01T22:23:50.157Z",
    dept: "CS",
    id: 109,
    name_: "Konduri Jeevan Varma",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Konduri_Jeevan_Varma_cv.png",
    title: "Siemens EDA | CS",
  },
  {
    category: "software",
    company: "DevRev",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Mohit_Hemnani_cv.png",
    createdAt: "2025-07-01T22:23:50.028Z",
    dept: "CS",
    id: 110,
    name_: "Karthik Banothu",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Mohit_Hemnani_cv.png",
    title: "DevRev | CS",
  },
  {
    category: "software",
    company: "Siemens",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Mohit_Hemnani_cv.png",
    createdAt: "2025-07-01T22:23:49.897Z",
    dept: "EE",
    id: 111,
    name_: "Mohit Hemnani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Mohit_Hemnani_cv.png",
    title: "Siemens | EE",
  },
  {
    category: "quant",
    company: "JPMorgan Chase",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Parth_sinha_cv.png",
    createdAt: "2025-07-01T22:23:49.765Z",
    dept: "MA",
    id: 112,
    name_: "Parth Sinha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Parth_sinha_cv.png",
    title: "JPMorgan Chase | MA",
  },
  {
    category: "core",
    company: "Inito",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Pradyumn_Mahajan_cv.png",
    createdAt: "2025-07-01T22:23:49.593Z",
    dept: "AE",
    id: 113,
    name_: "Pradyumn Mahajan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Pradyumn_Mahajan_cv.png",
    title: "Inito | AE",
  },
  {
    category: "software",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Pratik_Sonune_cv.png",
    createdAt: "2025-07-01T22:23:49.462Z",
    dept: "CS",
    id: 114,
    name_: "Pratik Sonune",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Pratik_Sonune_cv.png",
    title: "Texas Instruments | CS",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rajit_Bhojani_cv.png",
    createdAt: "2025-07-01T22:23:49.331Z",
    dept: "MA",
    id: 115,
    name_: "Rajit Bhojani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rajit_Bhojani_cv.png",
    title: "Goldman Sachs | MA",
  },
  {
    category: "core",
    company: "Google Hardware",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Roshmitha_Rajesh_cv.png",
    createdAt: "2025-07-01T22:23:49.198Z",
    dept: "EE",
    id: 116,
    name_: "Roshmitha Rajesh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Roshmitha_Rajesh_cv.png",
    title: "Google Hardware | EE",
  },
  {
    category: "core",
    company: "Inito",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ruturaj_Patil_cv.png",
    createdAt: "2025-07-01T22:23:49.068Z",
    dept: "MF",
    id: 117,
    name_: "Ruturaj Patil",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ruturaj_Patil_cv.png",
    title: "Inito | MF",
  },
  {
    category: "software",
    company: "DE Shaw",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shahil_Gupta_cv.png",
    createdAt: "2025-07-01T22:23:48.937Z",
    dept: "ME",
    id: 118,
    name_: "Shahil Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shahil_Gupta_cv.png",
    title: "DE Shaw | ME",
  },
  {
    category: "software",
    company: "Microsoft",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sharanya_Chakraborty_cv.png",
    createdAt: "2025-07-01T22:23:48.804Z",
    dept: "CS",
    id: 119,
    name_: "Sharanya Chakraborty",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sharanya_Chakraborty_cv.png",
    title: "Microsoft | CS",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Vivek_Malik_cv.png",
    createdAt: "2025-07-01T22:23:48.671Z",
    dept: "EE",
    id: 120,
    name_: "Vivek Malik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Vivek_Malik_cv.png",
    title: "Amazon | EE",
  },
  {
    category: "software",
    company: "UiPath",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Wakode_Sahil_Khushal_cv.png",
    createdAt: "2025-07-01T22:23:48.539Z",
    dept: "EC",
    id: 121,
    name_: "Wakode Sahil Khushal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Wakode_Sahil_Khushal_cv.png",
    title: "UiPath | EC",
  },
  {
    category: "software",
    company: "Twilio",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Vuriti_Keerthana_cv.png",
    createdAt: "2025-07-01T22:23:48.408Z",
    dept: "CS",
    id: 122,
    name_: "Vuriti Keerthana",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Vuriti_Keerthana_cv.png",
    title: "Twilio | CS",
  },
  {
    category: "data",
    company: "American Express",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Soumyadip_Paik_cv.png",
    createdAt: "2025-07-01T22:23:48.275Z",
    dept: "MA",
    id: 123,
    name_: "Soumyadip Paik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Soumyadip_Paik_cv.png",
    title: "American Express | MA",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sunrit_Sarkar_cv.png",
    createdAt: "2025-07-01T22:23:48.144Z",
    dept: "EC",
    id: 124,
    name_: "Sunrit Sarkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sunrit_Sarkar_cv.png",
    title: "Amazon | EC",
  },
  {
    category: "software",
    company: "Glean",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Tuhin_Mondal_cv.png",
    createdAt: "2025-07-01T22:23:48.013Z",
    dept: "CS",
    id: 125,
    name_: "Tuhin Mondal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Tuhin_Mondal_cv.png",
    title: "Glean | CS",
  },
  {
    category: "data",
    company: "ConvoZen.AI (NoBroker)",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Varun_Agrawal_cv.png",
    createdAt: "2025-07-01T22:23:47.883Z",
    dept: "CH",
    id: 126,
    name_: "Varun Agrawal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Varun_Agrawal_cv.png",
    title: "ConvoZen.AI (NoBroker) | CH",
  },
  {
    category: "finance",
    company: "J.P. Morgan Chase",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Vedant_Palit_cv.png",
    createdAt: "2025-07-01T22:23:47.751Z",
    dept: "IM",
    id: 127,
    name_: "Vedant Palit",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Vedant_Palit_cv.png",
    title: "J.P. Morgan Chase | IM",
  },
  {
    category: "core",
    company: "Qualcomm",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shashank_S_cv.png",
    createdAt: "2025-07-01T22:23:47.622Z",
    dept: "EC",
    id: 128,
    name_: "Shashank S",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shashank_S_cv.png",
    title: "Qualcomm | EC",
  },
  {
    category: "core",
    company: "SLB",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Abhishek_Sinha_cv.png",
    createdAt: "2025-07-01T22:23:47.491Z",
    dept: "ME",
    id: 129,
    name_: "Abhishek Sinha",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Abhishek_Sinha_cv.png",
    title: "SLB | ME",
  },
  {
    category: "software",
    company: "Adobe",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ajay_Paliwal_cv.png",
    createdAt: "2025-07-01T22:23:47.361Z",
    dept: "EE",
    id: 130,
    name_: "Ajay Paliwal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ajay_Paliwal_cv.png",
    title: "Adobe | EE",
  },
  {
    category: "software",
    company: "Amazon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Akash_Manna_cv.png",
    createdAt: "2025-07-01T22:23:47.227Z",
    dept: "MI",
    id: 131,
    name_: "Akash Manna",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Akash_Manna_cv.png",
    title: "AMAZON | MI",
  },
  {
    category: "software",
    company: "OLA ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Anirvan_Krishna_cv.png",
    createdAt: "2025-07-01T22:23:47.097Z",
    dept: "EE",
    id: 132,
    name_: "Anirvan Krishna",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Anirvan_Krishna_cv.png",
    title: "OLA | EE",
  },
  {
    category: "core",
    company: "SLB",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Anjali_sv_cv.png",
    createdAt: "2025-07-01T22:23:46.964Z",
    dept: "MI",
    id: 133,
    name_: "Anjali S Vallakudath",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Anjali_sv_cv.png",
    title: "SLB | MI",
  },
  {
    category: "data",
    company: "Nation with NaMo",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Arnab_Sarkar_cv.png",
    createdAt: "2025-07-01T22:23:46.831Z",
    dept: "AE",
    id: 134,
    name_: "Arnab Sarkar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Arnab_Sarkar_cv.png",
    title: "Nation with NaMo | AE",
  },
  {
    category: "quant",
    company: "Graviton",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Arudeep_Kumar_cv.png",
    createdAt: "2025-07-01T22:23:46.701Z",
    dept: "CS",
    id: 135,
    name_: "Arudeep Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Arudeep_Kumar_cv.png",
    title: "Graviton | CS",
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aruj_Mishra_cv.png",
    createdAt: "2025-07-01T22:23:46.556Z",
    dept: "EC",
    id: 136,
    name_: "Aruj Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aruj_Mishra_cv.png",
    title: "NVIDIA | EC",
  },
  {
    category: "core",
    company: "NVIDIA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ashvath_Krishnan_cv.png",
    createdAt: "2025-07-01T22:23:46.426Z",
    dept: "IE",
    id: 137,
    name_: "Ashvath Krishnan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ashvath_Krishnan_cv.png",
    title: "NVIDIA | IE",
  },
  {
    category: "software",
    company: "DEVREV",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Karthik_Banothu_cv.png",
    createdAt: "2025-07-01T22:23:46.292Z",
    dept: "CS",
    id: 138,
    name_: "Banothu Karthik",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Karthik_Banothu_cv.png",
    title: "DEVREV | CS",
  },
  {
    category: "software",
    company: "SIEMENS EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Uma_Nethrika_cv.png",
    createdAt: "2025-07-01T22:23:46.162Z",
    dept: "AE",
    id: 139,
    name_: "Bhandaru Uma Nethrika",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Uma_Nethrika_cv.png",
    title: "SIEMENS EDA | AE",
  },
  {
    category: "consultancy",
    company: "LEK",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Harsh_Bongirwar_cv.png",
    createdAt: "2025-07-01T22:23:46.031Z",
    dept: "AG",
    id: 140,
    name_: "Bongirwar Harsh Nitin",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Harsh_Bongirwar_cv.png",
    title: "LEK | AG",
  },
  {
    category: "core",
    company: "QUALCOMM",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Dhareddy_Vishwaksen_Reddy_cv.png",
    createdAt: "2025-07-01T22:23:45.901Z",
    dept: "EC",
    id: 141,
    name_: "Dhareddy Vishwaksen Reddy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Dhareddy_Vishwaksen_Reddy_cv.png",
    title: "QUALCOMM | EC",
  },
  {
    category: "core",
    company: "HUL ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Dhruv_Jain_cv_2026.png",
    createdAt: "2025-07-01T22:23:45.771Z",
    dept: "CH",
    id: 142,
    name_: "Dhruv Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Dhruv_Jain_cv_2026.png",
    title: "HUL | CH",
  },
  {
    category: "core",
    company: "TATA Steel",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Didwm_Mochahary_cv.png",
    createdAt: "2025-07-01T22:23:45.642Z",
    dept: "ME",
    id: 143,
    name_: "Didwm Mochahary",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Didwm_Mochahary_cv.png",
    title: "TATA Steel | ME",
  },
  {
    category: "software",
    company: "SALESFORCE",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Gaurav_Roy_cv.png",
    createdAt: "2025-07-01T22:23:45.513Z",
    dept: "CS",
    id: 144,
    name_: "Gaurav Roy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Gaurav_Roy_cv.png",
    title: "SALESFORCE | CS",
  },
  {
    category: "core",
    company: "JOHNSON & JOHNSON",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Harsh_Gupta_cv.png",
    createdAt: "2025-07-01T22:23:45.383Z",
    dept: "CH",
    id: 145,
    name_: "Harsh Raj Gupta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Harsh_Gupta_cv.png",
    title: "JOHNSON & JOHNSON | CH",
  },
  {
    category: "core",
    company: "INITO ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ruturaj_Patil_cv.png",
    createdAt: "2025-07-01T22:23:45.124Z",
    dept: "MF",
    id: 147,
    name_: "Patil Ruturaj Pravin",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ruturaj_Patil_cv.png",
    title: "INITO | MF",
  },
  {
    category: "software",
    company: "QUALCOMM",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Prasit_Mazumder_cv.png",
    createdAt: "2025-07-01T22:23:44.994Z",
    dept: "EC",
    id: 148,
    name_: "Prasit Mazumder",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Prasit_Mazumder_cv.png",
    title: "QUALCOMM | EC",
  },
  {
    category: "software",
    company: "COHESITY",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Anshu_Kumar_cv.png",
    createdAt: "2025-07-01T22:23:44.865Z",
    dept: "CS",
    id: 149,
    name_: "Priyanshu Gourav",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Anshu_Kumar_cv.png",
    title: "COHESITY | CS",
  },
  {
    category: "product",
    company: "DTDC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rahul_Ranjan_cv.png",
    createdAt: "2025-07-01T22:23:44.734Z",
    dept: "MF",
    id: 150,
    name_: "Rahul Ranjan",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rahul_Ranjan_cv.png",
    title: "DTDC | MF",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rajit_Bhojani_cv.png",
    createdAt: "2025-07-01T22:23:44.604Z",
    dept: "MA",
    id: 151,
    name_: "Rajit Jiten Bhojani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rajit_Bhojani_cv.png",
    title: "Goldman Sachs | MA",
  },
  {
    category: "software",
    company: "PATTERN",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ram_Mohan_Patel_cv.png",
    createdAt: "2025-07-01T22:23:44.475Z",
    dept: "AG",
    id: 152,
    name_: "Ram Mohan Patel",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ram_Mohan_Patel_cv.png",
    title: "PATTERN | AG",
  },
  {
    category: "core",
    company: "ITC",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Roctotpal_Sandilya_cv.png",
    createdAt: "2025-07-01T22:23:44.346Z",
    dept: "IE",
    id: 153,
    name_: "Roctotpal Sandilya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Roctotpal_Sandilya_cv.png",
    title: "ITC | IE",
  },
  {
    category: "product",
    company: "Battery Smart",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Ruturaj_Acharya_cv.png",
    createdAt: "2025-07-01T22:23:44.214Z",
    dept: "AE",
    id: 154,
    name_: "Ruturaj Acharya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Ruturaj_Acharya_cv.png",
    title: "Battery Smart | AE",
  },
  {
    category: "software",
    company: "JLR ",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sachin_Kadyan_cv.png",
    createdAt: "2025-07-01T22:23:44.085Z",
    dept: "CH",
    id: 155,
    name_: "Sachin",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sachin_Kadyan_cv.png",
    title: "JLR | CH",
  },
  {
    category: "software",
    company: "BNY Mellon",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sanskar_cv.png",
    createdAt: "2025-07-01T22:23:43.955Z",
    dept: "ME",
    id: 156,
    name_: "Sanskar Sadanand Yerule",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sanskar_cv.png",
    title: "BNY Mellon | ME",
  },
  {
    category: "software",
    company: "CORRIDOR PLATFORM",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Saroja_Bamra_cv.png",
    createdAt: "2025-07-01T22:23:43.825Z",
    dept: "HS",
    id: 157,
    name_: "Saroja Bamra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Saroja_Bamra_cv.png",
    title: "CORRIDOR PLATFORM | HS",
  },
  {
    category: "software",
    company: "AWL",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Sayan_Ghosh_cv.png",
    createdAt: "2025-07-01T22:23:43.696Z",
    dept: "CH",
    id: 158,
    name_: "Sayan Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Sayan_Ghosh_cv.png",
    title: "AWL | CH",
  },
  {
    category: "core",
    company: "QUALCOMM",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shashank_S_cv.png",
    createdAt: "2025-07-01T22:23:43.566Z",
    dept: "EC",
    id: 159,
    name_: "Shashank S",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shashank_S_cv.png",
    title: "QUALCOMM | EC",
  },
  {
    category: "software",
    company: "Trumio SDE",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shivam_Kumar_cv.png",
    createdAt: "2025-07-01T22:23:43.436Z",
    dept: "IM",
    id: 160,
    name_: "Shivam Kumar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shivam_Kumar_cv.png",
    title: "Trumio SDE | IM",
  },
  {
    category: "software",
    company: "ACCENTURE",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Shreya_Mishra_cv.png",
    createdAt: "2025-07-01T22:23:43.307Z",
    dept: "CH",
    id: 161,
    name_: "Shreya Mishra",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Shreya_Mishra_cv.png",
    title: "ACCENTURE | CH",
  },
  {
    category: "core",
    company: "TEXAS INSTRUMENTS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Pratik_Sonune_cv.png",
    createdAt: "2025-07-01T22:23:43.178Z",
    dept: "CS",
    id: 162,
    name_: "Sonune Pratik Ganesh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Pratik_Sonune_cv.png",
    title: "TEXAS INSTRUMENTS | CS",
  },
  {
    category: "software",
    company: "ZEPTO",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Adarsh_Tadiparthi_cv.png",
    createdAt: "2025-07-01T22:23:43.050Z",
    dept: "EE",
    id: 163,
    name_: "Tadiparthi Adarsh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Adarsh_Tadiparthi_cv.png",
    title: "ZEPTO | EE",
  },
  {
    category: "software",
    company: "SAMSUNG",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Tarang_Rangani_cv.png",
    createdAt: "2025-07-01T22:23:42.921Z",
    dept: "EE",
    id: 164,
    name_: "Tarang C Rangani",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Tarang_Rangani_cv.png",
    title: "SAMSUNG | EE",
  },
  {
    category: "finance",
    company: "PIRAMAL FINANCE",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo/Telu_Amruthavarshini_cv_2026.png",
    createdAt: "2025-07-01T22:23:42.790Z",
    dept: "CS",
    id: 165,
    name_: "Telu Amruthavarshini",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/swgcvrepo_thumbs/Telu_Amruthavarshini_cv_2026.png",
    title: "PIRAMAL FINANCE | CS",
  },
  {
    category: "product",
    company: "SPRINKLR",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Vedic_Dutta_cv.png",
    createdAt: "2025-07-01T22:23:42.660Z",
    dept: "CH",
    id: 166,
    name_: "Vedic Dutta",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Vedic_Dutta_cv.png",
    title: "SPRINKLR | CH",
  },
  {
    category: "quant",
    company: "Goldman Sachs",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/vumika_ghosh_cv.png",
    createdAt: "2025-07-01T22:23:42.529Z",
    dept: "ME",
    id: 167,
    name_: "Vumika Ghosh",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/vumika_ghosh_cv.png",
    title: "Goldman Sachs | ME",
  },
  {
    category: "software",
    company: "Databricks",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Abir_Roy_cv.png",
    createdAt: "2025-07-01T22:23:42.397Z",
    dept: "CS",
    id: 168,
    name_: "Abir Roy",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Abir_Roy_cv.png",
    title: "Databricks | CS",
  },
  {
    category: "core",
    company: "SLB",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Prakhar_Jain_cv.png",
    createdAt: "2025-07-01T22:23:42.226Z",
    dept: "CH",
    id: 169,
    name_: "Prakhar Jain",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Prakhar_Jain_cv.png",
    title: "SLB | CH",
  },
  {
    category: "software",
    company: "Cisco",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Akshat_Kapoor_cv.png",
    createdAt: "2025-07-01T22:23:42.096Z",
    dept: "CH",
    id: 170,
    name_: "Akshat Kapoor",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Akshat_Kapoor_cv.png",
    title: "Cisco | CH",
  },
  {
    category: "software",
    company: "Cisco",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aditya_Singh_Sisodia_cv.png",
    createdAt: "2025-07-01T22:23:41.966Z",
    dept: "MI",
    id: 171,
    name_: "Aditya Singh Sisodia",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aditya_Singh_Sisodia_cv.png",
    title: "Cisco | MT",
  },
  {
    category: "core",
    company: "Jaguar Land Rover",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Krishnendu_Nayek_cv.png",
    createdAt: "2025-07-01T22:23:41.837Z",
    dept: "EE",
    id: 172,
    name_: "Krishnendu Nayek",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Krishnendu_Nayek_cv.png",
    title: "Jaguar Land Rover | EE",
  },
  {
    category: "consultancy",
    company: "Genpact",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Subrat_Samal_cv.png",
    createdAt: "2025-07-01T22:23:41.707Z",
    dept: "IM",
    id: 173,
    name_: "Subrat Samal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Subrat_Samal_cv.png",
    title: "Jaguar Land Rover | IM",
  },
  {
    category: "core",
    company: "KLS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Subhajit_Chowdhury_cv.png",
    createdAt: "2025-07-01T22:23:41.576Z",
    dept: "IM",
    id: 174,
    name_: "Subhajit Chowdhury",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Subhajit_Chowdhury_cv.png",
    title: "KLA | IM",
  },
  {
    category: "product",
    company: "INITO-ANALYTICS",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Priyanshu_Garg_cv.png",
    createdAt: "2025-07-01T22:23:41.397Z",
    dept: "NA",
    id: 175,
    name_: "Priyanshu Garg",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Priyanshu_Garg_cv.png",
    title: "INITO-ANALYTICS | NA",
  },
  {
    category: "product",
    company: "Sperax",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Gaurav_Jindal_cv.png",
    createdAt: "2025-07-01T22:23:41.264Z",
    dept: "PH",
    id: 176,
    name_: "Gaurav Jindal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Gaurav_Jindal_cv.png",
    title: "Sperax | PH",
  },
  {
    category: "core",
    company: "Texas Instruments",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Anisha_Banerjee_cv.png",
    createdAt: "2025-07-01T22:23:41.087Z",
    dept: "IE",
    id: 177,
    name_: "Anisha Banerjee",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Anisha_Banerjee_cv.png",
    title: "Texas Instruments | IE",
  },
  {
    category: "consultancy",
    company: "Nation With Namo",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Aryan_Yesilanka_cv.png",
    createdAt: "2025-07-01T22:23:40.945Z",
    dept: "MI",
    id: 178,
    name_: "Aryan Yesilanka",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Aryan_Yesilanka_cv.png",
    title: "Nation With Namo | MI",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Byreddi_Sri_Chaitanya_cv.png",
    createdAt: "2025-07-01T22:23:40.815Z",
    dept: "CS",
    id: 179,
    name_: "Byreddi Sri Chaitanya",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Byreddi_Sri_Chaitanya_cv.png",
    title: "Google | CS",
  },
  {
    category: "software",
    company: "Google",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Maanasa_V_cv.png",
    createdAt: "2025-07-01T22:23:40.553Z",
    dept: "MA",
    id: 181,
    name_: "Vemulapalli Maanasa",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Maanasa_V_cv.png",
    title: "Google | MA",
  },
  {
    category: "software",
    company: "Twilio",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/RAJARSHI_MONDAL_cv.png",
    createdAt: "2025-07-01T22:23:40.372Z",
    dept: "CS",
    id: 182,
    name_: "Rajarshi Mondal",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/RAJARSHI_MONDAL_cv.png",
    title: "Twilio | CS",
  },
  {
    category: "core",
    company: "TATA Steel",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Rakshit_Raj_cv.png",
    createdAt: "2025-07-01T22:23:40.193Z",
    dept: "ME",
    id: 183,
    name_: "Rakshit Raj",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Rakshit_Raj_cv.png",
    title: "TATA Steel | ME",
  },
  {
    category: "core",
    company: "SIEMENS EDA",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images//Subinay_Toppo_cv.png",
    createdAt: "2025-07-01T22:23:40.005Z",
    dept: "EC",
    id: 184,
    name_: "Subhinay Toppo",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Subinay_Toppo_cv.png",
    title: "SIEMENS EDA | EC",
  },
  {
    category: "core",
    company: "Bajaj",
    cover: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/images/Tvisha_cv.png",
    createdAt: "2025-07-01T22:23:39.476Z",
    dept: "MF",
    id: 185,
    name_: "Tvisha Khakhar",
    profilecolor: "#FFC0CB",
    thumbnail: "https://pub-b84215cff3d84dd4b24d2c65cab03383.r2.dev/cvimages/Tvisha_cv.png",
    title: "Bajaj | MF",
  },
];
